import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    fileId: null,
};
export const viewMediaPageSlice = createSlice({
    name: "viewMediaPage",
    initialState,
    reducers: {
        setViewMediaPageFileId: (state, action) => {
            state.fileId = action.payload;
        },
        clearViewMediaPageFileId: (state) => {
            state.fileId = null;
        },
        resetViewMediaPage: () => initialState,
    },
});
export const { clearViewMediaPageFileId, resetViewMediaPage, setViewMediaPageFileId } = viewMediaPageSlice.actions;
export default viewMediaPageSlice.reducer;
